import classNames from 'classnames'

import Icon from '@components/Icon'

import { currencyFromSymbol } from 'shared/currency-utilities'
import { RateCurrency } from '../../utilities'

import styles from 'booking/components/BookingView/components/styles.module.scss'
import eventStyles from '../styles.module.scss'

const EventProductPriceInfo = ({ event, selectedEvent }) => (
    <div className="d-flex justify-content-between">
        <div className={classNames(styles.radioLabelWrap)}>
            <label htmlFor="eventProduct" className={styles.radioLabel}>
                <input
                    className={styles.radioInput}
                    type="radio"
                    value={selectedEvent?.rateId === event.rateId}
                    id="eventProduct"
                />
                <div className={classNames(styles.customRadio, eventStyles.customRadioIconEvents)}>
                    <Icon type={selectedEvent?.rateId === event.rateId ? 'radiobutton-on' : 'radiobutton-off'} />
                </div>
                <div className="d-flex  flex-column">
                    <span className={classNames(styles.rateName, eventStyles.eventProductName)}>{event.eventName}</span>
                    <span className={eventStyles.rateName}>{event.rateName}</span>
                </div>
            </label>
        </div>
        <div>
            <span className={classNames(styles.rateAmount, 'font-weight-bold')}>
                <RateCurrency rate={event} value={event.amount} currency={currencyFromSymbol(event.currencySymbol)} />
            </span>
        </div>
    </div>
)

export default EventProductPriceInfo
